import $ from 'jquery'

export default {
    name: 'ajout-inventaire',
    components: {},
    props: [],
    data () {
      return {
          loading: false,
          inventaire: {
              libelle: '',
              stock: '',
              date: '',

          }
      }
    },
    computed: {
      stocks() {
          return this.$store.getters['stocks']
      },
  
    },
    mounted () {
        setTimeout(() => {
            $('.p-content').fadeIn();
        }, 500);

        this.$store.dispatch("getStocks");
    },
    methods: {

        async submitForm() {
            const isValid = await this.$refs.observer.validate();


            if (isValid) {
                this.$store.dispatch("saveInventaire",this.inventaire).then(
                    this.$router.push({ path: `/inventaires` }) 
                );
            }
            
    
        }

  
    }
  }
  
  
  